<template>
  <div>
    <tableTitle>账单基本信息</tableTitle>
    <Form ref="formValidate" :label-width="125" inline>
      <div>
        <FormItem label="账单ID">
          <Input :value="billMainEntity.id" disabled />
        </FormItem>
        <FormItem label="参与人">
          <payee-select class="shrug" roleType="LEASEE" v-model="billMainEntity.memberId" disabled></payee-select>
        </FormItem>
        <FormItem label="合伙人">
          <payee-select class="shrug" roleType="LEASER" v-model="billMainEntity.leaserId" disabled></payee-select>
        </FormItem>
        <br />
        <FormItem label="标的物小类">
          <dict-select v-model="billMainEntity.targetType" namespace="target" id="type" :exclusion="[]" disabled />
        </FormItem>
        <FormItem label="账单类型">
          <dict-select v-model="billMainEntity.billType" namespace="default" id="billType" :exclusion="[]" disabled />
        </FormItem>
        <FormItem label="账单状态">
          <dict-select v-model="billMainEntity.status" namespace="default" id="leaseBillStatus" :exclusion="[]" disabled />
        </FormItem>
        <br />
        <FormItem label="账单日">
          <DatePicker type="date" :value="paramsData.billDate" style="width: 200px" disabled></DatePicker>
        </FormItem>
        <FormItem label="账单开始日">
          <DatePicker type="date" :value="paramsData.billStartDate" style="width: 200px" disabled></DatePicker>
        </FormItem>
        <FormItem label="账单截止日">
          <DatePicker type="date" :value="paramsData.billEndDate" style="width: 200px" disabled></DatePicker>
        </FormItem>
        <br />
        <FormItem label="租费">
          <Input :value="billMainEntity.rentalFee" readonly />
        </FormItem>
        <FormItem label="服务费">
          <Input :value="billMainEntity.serviceFee" readonly />
        </FormItem>
        <FormItem label="配送费">
          <Input :value="billMainEntity.deliverFee" readonly />
        </FormItem>
        <br />
        <FormItem label="回收费">
          <Input :value="billMainEntity.recycleFee" readonly />
        </FormItem>
        <FormItem label="清洗费">
          <Input :value="billMainEntity.cleanFee" readonly />
        </FormItem>
        <FormItem label="转户费">
          <Input :value="billMainEntity.transFee" readonly />
        </FormItem>
        <br />
        <FormItem label="赔偿金">
          <Input :value="billMainEntity.compensationFee" readonly />
        </FormItem>
        <FormItem label="管理服务费">
          <Input :value="billMainEntity.manageFee" readonly />
        </FormItem>
        <FormItem label="收益">
          <Input :value="billMainEntity.profitFee" readonly />
        </FormItem>
        <br />
        <FormItem label="剩余计租数">
          <Input :value="billMainEntity.endStock" readonly />
        </FormItem>
      </div>
    </Form>

    <tableTitle>账单付款信息</tableTitle>
    <Form ref="billFinanceInfo" :label-width="150" inline>
      <div>
        <div v-if="financeBillDetail.rentTaxUnitPrice">
          <FormItem label="原始含税租费">
            <Input :value="financeBillDetail.rentTaxUnitPrice" readonly />
          </FormItem>
          <FormItem label="账户余额抵扣">
            <Input :value="financeBillDetail.rentBalanceDeductAmt" readonly />
          </FormItem>
          <FormItem label="应付租费">
            <Input :value="financeBillDetail.rentReceivableAmt" readonly />
          </FormItem>
        </div>
        <div v-if="financeBillDetail.serviceTaxUnitPrice">
          <FormItem label="原始含税服务费">
            <Input :value="financeBillDetail.serviceTaxUnitPrice" readonly />
          </FormItem>
          <FormItem label="账户余额抵扣">
            <Input :value="financeBillDetail.serviceBalanceDeductAmt" readonly />
          </FormItem>
          <FormItem label="应付服务费">
            <Input :value="financeBillDetail.serviceReceivableAmt" readonly />
          </FormItem>
        </div>
        <div v-if="financeBillDetail.logisticsTaxUnitPrice">
          <FormItem label="原始含税运费">
            <Input :value="financeBillDetail.logisticsTaxUnitPrice" readonly />
          </FormItem>
          <FormItem label="账户余额抵扣">
            <Input :value="financeBillDetail.logisticsBalanceDeductAmt" readonly />
          </FormItem>
          <FormItem label="应付运费">
            <Input :value="financeBillDetail.logisticsReceivableAmt" readonly />
          </FormItem>
        </div>
        <div style="margin-left:50px;margin-bottom:20px;color:red;">
          ------------------------------------------------------------------------------------------------------------------------------------------------------------ 合计应付 : {{totalReceivableAmt}} 元
        </div>
        <div v-if="financeBillDetail.compensateTaxUnitPrice">
          <FormItem label="原始含税赔偿金">
            <Input :value="financeBillDetail.compensateTaxUnitPrice" readonly />
          </FormItem>
          <FormItem label="账户余额抵扣">
            <Input :value="financeBillDetail.compensateBalanceDeductAmt" readonly />
          </FormItem>
          <FormItem label="应付赔偿金">
            <Input :value="financeBillDetail.compensateReceivableAmt" readonly />
          </FormItem>
        </div>
        <div v-if="holdFinanceBillDetail">
          <FormItem label="原始含税管理服务费">
            <Input :value="holdFinanceBillDetail.manageTaxUnitPrice" readonly />
          </FormItem>
          <FormItem label="账户余额抵扣">
            <Input :value="holdFinanceBillDetail.manageBalanceDeductAmt" readonly />
          </FormItem>
          <FormItem label="应付管理服务费">
            <Input :value="holdFinanceBillDetail.manageReceivableAmt" readonly />
          </FormItem>
        </div>
        <div v-if="holdFinanceBillDetail">
          <FormItem label="原始含税收益">
            <Input :value="holdFinanceBillDetail.profitTaxUnitPrice" readonly />
          </FormItem>
          <FormItem label="账户余额抵扣">
            <Input :value="holdFinanceBillDetail.profitBalanceDeductAmt" readonly />
          </FormItem>
          <FormItem label="应付收益">
            <Input :value="holdFinanceBillDetail.profitReceivableAmt" readonly />
          </FormItem>
        </div>
      </div>
    </Form>

    <Tabs value="name1">
      <TabPane label="账单流水详情" name="name1">
        <Table :columns="billDetailCols" :data="billDetailList" style="margin:20px" border>
          <template slot-scope="{ row }" slot="dateType">
            <div>{{$options.filters['queryDict']('default','dateType',row.dateType)}}</div>
          </template>
        </Table>
      </TabPane>
      <TabPane label="合约流水详情" name="name4">
        <Table :columns="contractDetailCols" :data="contractDetailList" style="margin:20px" border></Table>
      </TabPane>
      <TabPane label="业务流水详情" name="name5">
        <Table :columns="bizDetailCols" :data="bizDetailList" style="margin:20px" border></Table>
      </TabPane>
      <TabPane label="账单调整详情" name="name2">
        <Table :columns="billAdjustCols" :data="billAdjustList" style="margin:20px" border>
          <template slot-scope="{ row }" slot="feeType">
            <div>{{$options.filters['queryDict']('default','feeType',row.feeType)}}</div>
          </template>
        </Table>
      </TabPane>
      <TabPane label="账单收益详情" name="name3" v-if="billMainEntity.billType=='01'">
        <Table :columns="billDetail4LeaserCols" :data="billDetail4LeaserList" style="margin:20px" border></Table>
      </TabPane>
    </Tabs>

    <Modal v-model="operateView" title="账单确认操作">
      <dict-select v-model="operateType" namespace="default" id="billOperate" :exclusion="billRefuseOption?[]:['0']" />
      <div slot="footer">
        <Button type="primary" @click="checkBill">确定</Button>
      </div>
    </Modal>

    <div style="text-align:center;width:700px;margin:30px">
      <Button v-if="paramsData.status=='00'" type="primary" style="margin-left:20px" @click="openOperateView">核对账单</Button>
      <Button type="warning" style="margin-left:20px" @click="back">返回</Button>
    </div>
    <Spin size="large" fix v-if="spinShow"></Spin>
  </div>
</template>

<script>
import tableTitle from '@/components/tableTitle/tableTitle.vue';
import dictSelect from '@/components/select/dict-select.vue';
import payeeSelect from '@/components/select/payee-select.vue';

export default {
  components: {
    payeeSelect,
    tableTitle,
    dictSelect,
  },
  props: ['paramsData'],
  data() {
    return {
      billRefuseOption: false,//[核对账单]屏蔽"拒绝"选项
      billMainEntity: {},
      billDetailList: [],
      billAdjustList: [],
      billDetail4LeaserList: [],
      financeBillDetail: {},
      holdFinanceBillDetail: {},
      billDetailCols: [
        { title: '流水日期', key: 'detailDate' },
        { title: '流水类型', slot: 'dateType' },
        { title: '前日存量', key: 'lastDayStock' },
        { title: '起租数', key: 'newLeaseAmount' },
        { title: '停止计租数', key: 'stopLeaseAmount' },
        { title: '今日存量', key: 'todayStock' },
        { title: '租金', key: 'rentalFee' },
        { title: '服务费', key: 'serviceFee' },
        { title: '配送费', key: 'deliverFee' },
        { title: '回收费', key: 'recycleFee' },
        { title: '清洗费', key: 'cleanFee' },
        { title: '转户费', key: 'transFee' },
        { title: '赔偿金', key: 'compensationFee' },
      ],
      operateView: false,
      operateType: '',
      billDetail4LeaserCols: [
        { title: '流水日期', key: 'detailDate' },
        { title: '发行数量', key: 'issueNum' },
        { title: '扣减数量', key: 'cancellationNum' },
        { title: '起租数量', key: 'leaseNum' },
        { title: '归还数量', key: 'returnNum' },
        { title: '当日有效数', key: 'balance' },
        { title: '前期调整', key: 'previousCleared' },
        { title: '日租价格', key: 'dailyRental' },
        { title: '当日租费', key: 'currentRental' },
        { title: '日服务价格', key: 'dailyService' },
        { title: '当日服务费', key: 'currentService' },
        { title: '日收益单价', key: 'dailyProfit' },
        { title: '日收益', key: 'currentProfit' },
      ],
      billAdjustCols: [
        { title: '费用类型', slot: 'feeType' },
        { title: '金额', key: 'amount' },
        { title: '备注描述', key: 'remark' },
      ],
      contractDetailCols: [
        { title: '合约编号', key: 'contractId' },
        { title: '起租日期', key: 'deliveredDate' },
        { title: '起租数量', key: 'amount' },
        { title: '当月停租数量', key: 'stopAmount' },
        { title: '存量', key: 'stock' },
        { title: '租金', key: 'rentalFee' },
        { title: '服务费', key: 'serviceFee' },
        { title: '配送费', key: 'deliverFee' },
        { title: '回收费', key: 'recycleFee' },
        { title: '清洗费', key: 'cleanFee' },
        { title: '转户费', key: 'transFee' },
        { title: '赔偿金', key: 'compensationFee' },
      ],
      bizDetailCols: [
        { title: '业务类型', key: 'type' },
        { title: '合约编号', key: 'contractId' },
        { title: '业务日期日期', key: 'occurDate' },
        { title: '业务数量', key: 'amount' },
        { title: '租金', key: 'rentalFee' },
        { title: '服务费', key: 'serviceFee' },
        { title: '配送费', key: 'deliverFee' },
        { title: '回收费', key: 'recycleFee' },
        { title: '清洗费', key: 'cleanFee' },
        { title: '转户费', key: 'transFee' },
        { title: '转户租费补贴', key: 'transRentalFee' },
        { title: '转户服务费补贴', key: 'transServiceFee' },
        { title: '赔偿金', key: 'compensationFee' },
        { title: '业务编号', key: 'bizId' },
        { title: '回收数量', key: 'recycledAmount' },
      ],
      spinShow: false,
      contractDetailList:[],
      bizDetailList:[]
    }
  },
  computed: {
    totalReceivableAmt: function () {
      let rental = !this.financeBillDetail.rentReceivableAmt ? 0 : this.financeBillDetail.rentReceivableAmt;
      let service = !this.financeBillDetail.serviceReceivableAmt ? 0 : this.financeBillDetail.serviceReceivableAmt;
      let logistics = !this.financeBillDetail.logisticsReceivableAmt ? 0 : this.financeBillDetail.logisticsReceivableAmt;
      let total = rental + service + logistics;
      return (new Number(total)).toFixed(4);
    }
  },
  async mounted() {
    await this.dict.initDict([{ namespace: 'default', id: 'dateType' }, { namespace: 'default', id: 'feeType' }]);
    if (this.paramsData.id) {
      this.queryBillDetail();
    }
  },
  methods: {
    queryBillDetail() {
      let params = {
        url: 'http://CORE-CONTRACT/messageService/billService/queryBillDetail',
        body: { billId: this.paramsData.id }
      }
      this.spinShow = true;
      this.invoke(params).then(({ billMainEntity, billDetailList,contractDetailList,bizDetailList, billAdjustList, billDetail4LeaserList, financeBillDetail, holdFinanceBillDetail }) => {
        this.billMainEntity = billMainEntity;
        this.billDetailList = billDetailList;
        this.billAdjustList = billAdjustList;
        this.billDetail4LeaserList = billDetail4LeaserList;
        this.financeBillDetail = financeBillDetail;
        this.holdFinanceBillDetail = holdFinanceBillDetail;
        this.contractDetailList = contractDetailList;
        this.bizDetailList = bizDetailList;
        this.spinShow = false;
      });
    },
    openOperateView() {
      this.operateType = '';
      this.operateView = true;
    },
    checkBill() {
      let okFn = () => {
        let params = {
          url: 'http://CORE-CONTRACT/messageService/billService/billCheck',
          body: {
            billId: this.paramsData.id,
            operateType: this.operateType
          }
        }
        this.invoke(params).then((rs) => {
          if (rs) {
            this.$Message.info('操作成功!');
            this.back();
          }
        });
      }
      this.$Modal.confirm({
        title: '账单确认',
        content: '请确认此操作',
        onOk: okFn
      })
    },
    back() {
      this.$emit('on-finish', {});
    }
  }
}
</script>